const contentForm = document.querySelector('.wpcf7');
const contentPeople = document.querySelector('.single-content--people .people-content__content-right .text')
const scrollInfoBlock = document.querySelector('.scroll-info');
const contactContainer = document.querySelector('.page-content--contact .wp-block-column:last-child');

if(contentForm && scrollInfoBlock && (window.innerWidth > 1020)) {
  showScrollInfo(contentForm);
}

if(contentPeople && scrollInfoBlock && (window.innerWidth > 1020)) {
  showScrollInfo(contentPeople);
}

if(contactContainer && scrollInfoBlock && (window.innerWidth > 1020)) {
  showScrollInfo(contactContainer);
}

function showScrollInfo(thisElem) {
  if(thisElem && scrollInfoBlock) {
    var hasVerticalScrollbar  = thisElem.scrollHeight  > thisElem.clientHeight;
  
    if(hasVerticalScrollbar ) {
      scrollInfoBlock.style.display = "flex";
    }
  }
}